export class AudienceSearchFilter {
    constructor(Field, Operator, Value) {
        this.Field = Field;
        this.Operator = Operator;
        this.Value = Value;
    }
}
//# sourceMappingURL=AudienceSearchFilter.js.map